import './index.scss';
import arrowRight from '../../../../assets/images/provisional-offer/arrow-right.svg';
import listNoteIcon from '../../../../assets/images/provisional-offer/listnotepad.svg';

const CosignerDocumentSection = ({ onClick }) => {
  return (
    <>
      <div className="cosigner-doc-card" data-testid="cosigner-doc-card" onClick={onClick}>
        <div className="cosigner-doc-content">
          <img className="cosigner-doc-list-note" src={listNoteIcon} alt="List Note Icon" />
          <p className="cosigner-doc-text">See Co-signer requirements</p>
          <img className="cosigner-doc-right-arrow" src={arrowRight} alt="Right Arrow" />
        </div>
      </div>
    </>
  );
};

export default CosignerDocumentSection;
